import { useRecoilState } from "recoil";
import { cauc } from "../atom";

const useCaucState = () => {
    return useRecoilState(cauc);
};

export default useCaucState;